import { buildCdnImageUrl } from '@susu/order-list'

import { getApiBaseUrl } from '../config/api.config'
import { getTokenFromUrl } from '../utils/auth'

import type { EnvironmentWithChina } from '../App'
import type { WardrobeItem } from '../types/wardrobe'

export class WardrobeApiError extends Error {
  constructor(
    message: string,
    public statusCode?: number,
  ) {
    super(message)
    this.name = 'WardrobeApiError'
  }
}

export function buildWardrobeImageUrl(
  imageUri: string | null,
  width = 360,
): string | undefined {
  return buildCdnImageUrl(imageUri, { width })
}

export async function fetchWardrobe(
  accountNumber: string,
  env: EnvironmentWithChina,
  authToken?: string,
): Promise<WardrobeItem[]> {
  const normalizedAccountNumber = accountNumber.trim()

  if (!normalizedAccountNumber) {
    throw new WardrobeApiError('Missing account number.')
  }

  const baseUrl = getApiBaseUrl(env)
  const url = `${baseUrl}/public/profileapi/${encodeURIComponent(normalizedAccountNumber)}/wardrobe`
  const token = authToken || getTokenFromUrl()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(url, {
    method: 'GET',
    headers,
    credentials: 'omit',
  })

  if (!response.ok) {
    throw new WardrobeApiError('Failed to fetch wardrobe', response.status)
  }

  return response.json() as Promise<WardrobeItem[]>
}
